export default __webpack_public_path__ + "static/media/FlyingFrog1.093af269.png";